import React from 'react';
import Modal from 'react-modal';

const ConfirmModal = ({ isOpen, onClose, onConfirm, dayNumber }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={`Confirm delete for Day ${dayNumber}`}
      className="modal"
    >
      <h2>Confirm Delete</h2>
      <p>Are you sure you want to delete Day {dayNumber}?</p>
      <div className="modal-buttons">
        <button onClick={onConfirm}>Confirm</button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;